import React from "react"

const NotFoundIconLarge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="167"
      height="87"
      viewBox="0 0 167 87"
      fill="none"
    >
      <path
        d="M73.5 68.25C92.0015 68.25 107 53.2515 107 34.75C107 16.2485 92.0015 1.25 73.5 1.25C54.9985 1.25 40 16.2485 40 34.75C40 53.2515 54.9985 68.25 73.5 68.25Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1321 60.7439C69.8908 61.0685 71.6801 61.2372 73.5 61.25C88.1355 61.25 100 49.3855 100 34.75C100 20.1145 88.1355 8.25 73.5 8.25C69.7404 8.25 66.1636 9.03293 62.9238 10.4446C57.2938 12.8979 52.6816 17.2499 49.896 22.6919C48.0445 26.3089 47 30.4075 47 34.75C47 38.69 47.8599 42.4292 49.4021 45.7901C50.5032 48.1896 51.9521 50.3963 53.6843 52.3456"
        fill="white"
      />
      <path
        d="M68.1321 60.7439C69.8908 61.0685 71.6801 61.2372 73.5 61.25C88.1355 61.25 100 49.3855 100 34.75C100 20.1145 88.1355 8.25 73.5 8.25C69.7404 8.25 66.1636 9.03293 62.9238 10.4446C57.2938 12.8979 52.6816 17.2499 49.896 22.6919C48.0445 26.3089 47 30.4075 47 34.75C47 38.69 47.8599 42.4292 49.4021 45.7901C50.5032 48.1896 51.9521 50.3963 53.6843 52.3456"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        stroke-linecap="round"
      />
      <path
        d="M56.7969 55.3247C58.945 57.0707 61.3718 58.487 64.0003 59.4966"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        stroke-linecap="round"
      />
      <path
        d="M101 61.25L107 67.25"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.029 66.2803C104.136 68.173 104.136 71.2417 106.029 73.1344L117.114 84.2197C119.007 86.1124 122.076 86.1124 123.968 84.2197C125.861 82.327 125.861 79.2583 123.968 77.3656L112.883 66.2803C110.99 64.3875 107.922 64.3875 106.029 66.2803Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        d="M111 68.25L122 79.25"
        stroke="white"
        strokeWidth="2.5"
        stroke-linecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.0005 23.25C67.0005 34.848 76.4025 44.25 88.0005 44.25C90.2789 44.25 92.4725 43.8872 94.5267 43.2162C91.1737 51.5371 83.023 57.4107 73.5005 57.4107C60.9854 57.4107 50.8398 47.2652 50.8398 34.75C50.8398 23.4096 59.1702 14.0148 70.0455 12.3511C68.1135 15.5293 67.0005 19.2597 67.0005 23.25Z"
        fill="#F5F7F7"
      />
      <path
        d="M74 16.25C72.7266 16.25 71.4825 16.3753 70.2793 16.6142M66.6447 17.7261C59.8039 20.6008 55 27.3644 55 35.25"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        stroke-linecap="round"
      />
      <path
        d="M127.176 35.0273H119M133.5 27.25H116.324H133.5ZM140.5 27.25H138.279H140.5Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.1743 57.0273H28.9985M32.4985 48.25H15.3228H32.4985ZM9.49854 48.25H5.27734H9.49854Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default NotFoundIconLarge
